import { Box, Typography } from '@material-ui/core';
import ProcedureProgress from '../../ProcedureProgress';
import { ButtonLabel, MainButton, TimeOutButton } from '../../common';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { ProcedureState } from '@/components/pages/kiosk/tablet/util/procedureSteps';
import React from 'react';
import { H3 } from '@/se/components/typography';
import { Exit } from '../../Modal';
import Troubleshooting from '@/components/pages/kiosk/tablet/Troubleshooting';
import { WithWorking } from '../OperationRoomTabletV2';
import { Box4, Text5 } from '@/components/pages/kiosk/tablet/v2/styles';
import { Loading } from './Loading';

type ProcedureControlsSectionProps = {
  roomName: string;
  roomStatus: string;
  procedureState: ProcedureState | null;
  isPreviousPatient: boolean;
  formattedOrOutTime: string | null;
};

export const ProcedureControlsSection = ({
  roomName,
  roomStatus,
  procedureState,
  isPreviousPatient,
  formattedOrOutTime,
}: ProcedureControlsSectionProps) => {
  const nextStepExists = !!procedureState?.next;

  return (
    <Box style={{ display: 'flex', flexDirection: 'column', flex: 3 }}>
      <Troubleshooting roomName={roomName} />
      <Box
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <ProcedureProgress status={roomStatus} />
      </Box>
      {nextStepExists ? (
        <Box display="flex" justifyContent="center">
          <Loading fn={procedureState?.prev ?? undefined} afterDelayMs={1500}>
            {(handler, isLoading) => (
              <TimeOutButton onClick={handler ?? undefined} disabled={!handler || isLoading}>
                <WithWorking working={isLoading} size={'4rem'}>
                  <Box fontSize={'6.5em'}>
                    <ChevronLeftIcon fontSize={'inherit'} />
                  </Box>
                </WithWorking>
                <ButtonLabel>{'Undo'}</ButtonLabel>
              </TimeOutButton>
            )}
          </Loading>

          <Loading fn={procedureState?.next ?? undefined} afterDelayMs={1500}>
            {(handler, isLoading) => (
              <MainButton onClick={handler ?? undefined} disabled={!handler || isLoading}>
                <WithWorking working={isLoading} size={'4rem'}>
                  <Box fontSize={'6.5em'}>
                    <ChevronRightIcon fontSize={'inherit'} />
                  </Box>
                </WithWorking>
                <ButtonLabel>{procedureState?.nextLabel}</ButtonLabel>
              </MainButton>
            )}
          </Loading>
        </Box>
      ) : (
        <Box4>
          {formattedOrOutTime && (
            <Typography
              variant="h4"
              style={{
                marginBottom: '1rem',
                color: 'rgba(255, 255, 255, 0.8)',
              }}
            >
              Exited OR: {formattedOrOutTime}
            </Typography>
          )}
          <H3 style={{ opacity: '.5' }}>No further action needed</H3>
          <Text5>
            This procedure will be automatically marked as complete <br /> as soon as the patient leaves the room.
          </Text5>
          {!isPreviousPatient && (
            <Loading fn={procedureState?.prev ?? undefined} afterDelayMs={1500}>
              {(handler, isLoading) => (
                <Exit style={{ minHeight: '1em' }} onClick={handler ?? undefined} disabled={!handler || isLoading}>
                  <WithWorking working={isLoading}>Undo</WithWorking>
                </Exit>
              )}
            </Loading>
          )}
        </Box4>
      )}
    </Box>
  );
};
